import { useMemo, useEffect } from 'react';
import { showProjectBoundsPolygon, hideProjectBoundsPolygon } from '../utils/cesiumHelpers';
export const useProjectBoundsWithViewMode = (viewer, selectedProject, viewMode, boundsVisible) => {
    const shouldShowBounds = useMemo(() => {
        return !!selectedProject && viewMode === 'project-structure' && boundsVisible;
    }, [selectedProject, viewMode, boundsVisible]);
    useEffect(() => {
        if (!viewer)
            return;
        if (shouldShowBounds && selectedProject) {
            showProjectBoundsPolygon(viewer, selectedProject);
        }
        else {
            hideProjectBoundsPolygon(viewer);
        }
    }, [shouldShowBounds, viewer, selectedProject]);
    return { shouldShowBounds };
};
